document.querySelector('.custom_description .read_more')?.addEventListener('click', function() {
    let c_des = document.querySelector('.c_des');
    let custom_description = document.querySelector('.custom_description');
    let Description_heading_icon = document.querySelector('.Description_heading_icon');
    let readMoreButton = document.querySelector('.custom_description .read_more');
    const productInfo = document.querySelector('.product-info'); // Select your product-info element

    if (c_des.classList.contains('active_description' || 'active_icon' )) {
        c_des.style.height = '130px';
        c_des.classList.remove('active_description');
        Description_heading_icon.classList.remove('active_icon');
        productInfo.classList.remove('active_info');
        // readMoreButton.innerText = 'Lees meer'; // Change button text to 'Read more'
        readMoreButton.classList.contains('read_more--active') ? readMoreButton.classList.remove('read_more--active') : '' ;
        readMoreButton.innerText = readMoreButton.getAttribute('data-readmore'); // Restore original text
        
        custom_description.scrollIntoView({ behavior: 'smooth', block: 'start' });
        console.log('Height set to default: 133px');
    } else {
        let elements = c_des.children;
        let totalHeight = 0;

        for (let i = 0; i < elements.length; i++) {
            let element = elements[i];
            let style = window.getComputedStyle(element);
            let margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
            totalHeight += element.offsetHeight + margin;
        }

        c_des.style.height = totalHeight + 'px';
        c_des.classList.add('active_description');
        Description_heading_icon.classList.add('active_icon');
        productInfo.classList.add('active_info');
        !readMoreButton.classList.contains('read_more--active') ? readMoreButton.classList.add('read_more--active') : '' ;
        readMoreButton.innerText = readMoreButton.getAttribute('data-readless'); // Set alternative text
        // readMoreButton.innerText = 'lees minder'; // Change button text to 'Read less'
        console.log('Calculated height:', totalHeight + 'px');
    }

    // Scroll into view with smooth behavior

});



document.querySelector('.ctm_read_more_block .read_more')?.addEventListener('click', function() {
    let prose = document.querySelector('.ctm_read_more_block .prose');
    let ctm_read_more_block = document.querySelector('.ctm_read_more_block');
    let ctm__fullDescription = document.querySelector('.ctm__fullDescription');
    let custom_read_content = document.querySelector('.custom_read_content');
    let readMoreButton = document.querySelector('.ctm_read_more_block .read_more');
    const productInfo = document.querySelector('.product-info'); // Select your product-info element

    if (!prose) {
        console.error('.prose element not found');
        return; // Exit the function if .prose element is not found
    }

    if (prose.classList.contains('active_prose' || 'active_arrow')) {
        prose.style.height = '133px';
        prose.classList.remove('active_prose');
        productInfo.classList.remove('active_info');
        custom_read_content.classList.remove('active_arrow');
        readMoreButton.classList.contains('read_more--active') ? readMoreButton.classList.remove('read_more--active') : '' ;
        ctm_read_more_block.scrollIntoView({ behavior: 'smooth', block: 'start' });
        readMoreButton.innerText = readMoreButton.getAttribute('data-readmore'); // Restore original text
        console.log('Height set to default: 133px');
    } else {
        let totalHeight = 0;

        // Add height of ctm__fullDescription plus 30px if it exists
        if (ctm__fullDescription) {
            totalHeight = ctm__fullDescription.offsetHeight;
        }

        !readMoreButton.classList.contains('read_more--active') ? readMoreButton.classList.add('read_more--active') : '' ;
        prose.style.height = totalHeight + 'px';
        prose.classList.add('active_prose');
        // productInfo.classList.add('active_info');
        custom_read_content.classList.add('active_arrow');
        readMoreButton.innerText = readMoreButton.getAttribute('data-readless'); // Set alternative text
        console.log('Calculated height:', totalHeight + 'px');
    }
});



// arrow icon rotate 

document.querySelector('.custom_description .down_arrow')?.addEventListener('click', function() {
    document.querySelector('.custom_description .read_more').click();
});

document.querySelector('.ctm_read_more_block .down_arrow')?.addEventListener('click', function() {
    document.querySelector('.ctm_read_more_block .read_more').click();
});




window.onload = function(){
    setTimeout(function() {
        document.querySelector('.tpo_option-label .tpo_shape_null')?.classList.add('tpo_is_checked_swatches')
    }, 500);
}
// // sticky header 
// document.addEventListener('DOMContentLoaded', () => {
//     const header = document.querySelector('header'); // Select your header element
//     const productInfo = document.querySelector('.product-info'); // Select your product-info element

//     if (header && productInfo) {
//         const headerHeight = header.offsetHeight; // Get the header's offset height

//         // Apply the sticky position and top value to the product-info element
//         productInfo.style.position = 'sticky';
//         productInfo.style.top = `${headerHeight}px`;
//     }
// });

// document.addEventListener('DOMContentLoaded', function() {
//   setTimeout(function() {
//     let ctmFormText = `<div class="ctmAlreadyAccount">Already have an account<a href='/account/login' target="_blank">Login here</a></div>`;
//     document.querySelector('.bss-b2b-registration-form-title').insertAdjacentHTML('beforeend', ctmFormText);
//   }, 1500)
// });
